module.exports = import("https://cdn.skypack.dev/react-organogram");;